const RaceModule = () => import(/* webpackChunkName: "race-module" */ './views/Module.vue');
const RacingCategory = () => import(/* webpackChunkName: "racing-category" */ './views/RacingCategory.vue');
const RaceRoutes = {
    path: '/',
    component: RaceModule,
    children: [
        {
            path: 'racing-category/:type',
            name: 'racing-category',
            component: RacingCategory
        }
    ],
}   

export default RaceRoutes;